import { EcommerceAPI } from "../Client";

const getPreviewPayload = (payload = {}) => {
  if (payload?.dto) return payload.dto;

  const { id, productId, ...previewPayload } = payload;
  return previewPayload;
};

export const postProductPreviewApi = async (payload = {}) => {
  try {
    const response = await EcommerceAPI.post(
      "/product/preview",
      getPreviewPayload(payload)
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const updateProductPreviewApi = async (payload = {}) => {
  try {
    const id = payload?.id ?? payload?.dto?.id ?? "";
    const response = await EcommerceAPI.put(
      `/product/preview?id=${id || ""}`,
      getPreviewPayload(payload)
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteProductPreviewApi = async (payload = {}) => {
  try {
    const id = payload?.id ?? payload;
    const response = await EcommerceAPI.delete(`/product/preview?id=${id || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getProductPreviewApi = async (payload = {}) => {
  try {
    const id = payload?.id ?? payload;
    const response = await EcommerceAPI.get(`/product/preview?id=${id || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getAllProductPreviewApi = async (payload = {}) => {
  try {
    const productId = payload?.productId ?? payload;
    const response = await EcommerceAPI.get(
      `/product/preview/all?productId=${productId || ""}`
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};
